import { Environment } from "./type";

export const environment: Environment = {
  production: false,
  sentryDsn: "https://38019c7053a0666c474ca7ba551550eb@o515678.ingest.us.sentry.io/4506948733108224",
  apiUrlBsV1: "https://sandbox-api.poshvine.com/bs/v1/",
  apiUrlCsV1: "https://sandbox-api.poshvine.com/cs/v1/",
  apiUrlPaV1: "https://sandbox-api.poshvine.com/pa/v1/",
  apiUrlPsV1: "https://sandbox-api.poshvine.com/ps/v1/",
  apiUrlBsInternal: "https://sandbox-api.poshvine.com/bs/internal/",
  clientId: "e3930874-02ea-4bec-a40a-60b059973465",
  projectId: "356b468b-cabd-45f0-9466-74f00744992e",
};
